import { render, staticRenderFns } from "./SelectedRoutineAssign.vue?vue&type=template&id=1949e847&"
import script from "./SelectedRoutineAssign.vue?vue&type=script&lang=ts&"
export * from "./SelectedRoutineAssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports